export const registerPermissions = {
  // 'Workspaces': ['create'],
  // 'Workspace': ['read', '_step_', 'release', 'delete'],
  // 'Files': ['_root_', 'upload', 'delete'],
  // 'Step': ['read'],
  // 'TrainingTasks': ['read', 'create', 'classify', 'weight'],
  // 'Models': ['read', 'select', 'infer'],
  // 'Labeling': ['read', 'write', 'skip', 'help', 'save', 'signoff'],
  // 'Results': ['_root_', 'import', 'write', 'save', 'export'],
  // 'Tags': ['_root_', 'management', 'create', 'delete']
  // 'Workspaces': ['create'],
  // 'Workspace': ['read', 'release', 'delete']
}

export const getProtectedPermissions = (resourceName, defaultPermissions) => {
  const permissions = {}
  if (resourceName in registerPermissions) {
    for (let behavior in defaultPermissions) {
      if (defaultPermissions.hasOwnProperty(behavior)) {
        if (registerPermissions[resourceName].includes(behavior)) {
          permissions[behavior] = defaultPermissions[behavior]
        }
      }
    }
  }
  return permissions
}

export const getProtectedBehaviors = (resourceName, behaviors) => {
  const protectedBehaviors = []
  if (resourceName in registerPermissions) {
    for (let behavior of behaviors) {
      if (registerPermissions[resourceName].includes(behavior)) {
        protectedBehaviors.push(behavior)
      }
    }
  }
  return protectedBehaviors
}
